<div class="animated fadeIn main">
    <div class="text-center border-bottom py-2">
        <h1 class="my2-2">Datos de contacto</h1>
        <h2 class="">Completá tus datos para continuar</h2>
    </div>
    <form class="mt-3" [formGroup]="form" autocomplete="off" appInvalidControlScroll controlClass="app-user-data-input" >
        <app-user-data-input label = "Nombre"
                             marginTop = "false"
                             formControlName="name"
                             placeholder="Ej: Juan"
                             [invalidInput]="invalidName">
        </app-user-data-input>
        <app-user-data-input label = "Apellido"
                             formControlName="lastName"
                             placeholder="Ej: Perez"
                             [invalidInput]="invalidLastName">
        </app-user-data-input>
        <app-user-data-input label = "Empresa"
                             formControlName="company"
                              placeholder="Ej: Mi empresa"
                             [invalidInput]="invalidCompany">
        </app-user-data-input>
        <app-user-data-input label = "Cargo"
                             formControlName="position"
                              placeholder="Ej: Analista de productos"
                             [invalidInput]="invalidPosition">
        </app-user-data-input>
        <div class="my-3 d-flex justify-content-center">
            <app-custom-button label="Volver"
                               button_style="simple"
                               [newRoute]="['introduccion']"
                               class="mr-5">
            </app-custom-button>
            <app-custom-button label="Siguiente"
                               button_style="outline"
                               (click)="saveChanges()">
            </app-custom-button>
        </div>
    </form> 
</div>

